'use strict';

var React = require('react');
var keyboard = require('../../../helpers/keyboard.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const Radio = React.forwardRef(({ disabled = false, checked = false, onChange, ...props }, ref) => (React__default.default.createElement(styles.Styled.Container, { ...props, tabIndex: disabled ? undefined : 0, role: "radio", "aria-disabled": disabled, "aria-checked": checked, ref: ref, onKeyDown: event => {
        if (keyboard.isKey('space')(event)) {
            event.preventDefault();
            onChange?.(!checked);
        }
        props.onKeyDown?.(event);
    }, onClick: disabled
        ? undefined
        : event => {
            onChange?.(!checked);
            props.onClick?.(event);
        }, disabled: disabled, checked: checked },
    React__default.default.createElement("input", { type: "radio", checked: checked, disabled: disabled, style: { display: 'none' }, readOnly: true }),
    React__default.default.createElement(styles.Styled.OuterCircle, { disabled: disabled, checked: checked }, checked && React__default.default.createElement(styles.Styled.InnerCircle, { disabled: disabled, checked: true })))));

exports.Radio = Radio;
//# sourceMappingURL=component.js.map
